import React, { useContext } from "react";
import { RootStoreContext } from "../store/rootStore";
import { observer } from "mobx-react-lite";
import { ICoCurricularCard } from "../models/cocurricular";

interface IProps {
  card: ICoCurricularCard;
  index: number;
}


const CoCurricularCard:React.FC<IProps> = observer(({card, index} : IProps) => {

  const rootStore = useContext(RootStoreContext);

  const {ccSetCardChosen, ccImage} = rootStore.coCurricularStore;

  const cardClicked = (e, card: ICoCurricularCard) => {
    e.preventDefault();
    ccSetCardChosen(card);
  }

  const shortSummary = (content: string|null) => {
    const wordSplit = 30;
    if(content === null || content.length < 50) return "";
    const splitArray = content.split(' ');
    if(splitArray.length < wordSplit) return content;
    return splitArray.slice(0, wordSplit).join(' ') + "...";
  }

  return (
    <>
      <div className='the-wall__card' key={card.slug}>
        <div className={`the-wall__card_inner`}>
          {card.coCurricular.image !== null ?
            <div className='the-wall__cc-background-image' style={{backgroundImage: `url(${card.coCurricular.image.node.mediaItemUrl})`}}></div>
            : null
          }
          <h2 onClick={(e) => cardClicked(e, card)}>{card.title}</h2>
          <div className='the-wall__card-body' dangerouslySetInnerHTML={{__html: shortSummary(card.content)}} />
          <a href='#' onClick={(e) => cardClicked(e, card)}>Read more <i className="fa-light fa-circle-plus"></i></a>
          <div className='the-wall__card-times'  dangerouslySetInnerHTML={{__html: card.coCurricular.time}}></div>
          <div className='the-wall__cc-forms'>Open to:  {card.coCurricular.form.nodes.length === 13 ? 'all' :
            card.coCurricular.form.nodes.map(form => (
              <span>{form.name}</span>
            ))
          }
          </div>
        </div>
      </div>
      {index % 11 === 2 || index % 11 === 4 || index % 11 === 7 || index % 11 === 9 ?
        <div className='the-wall__card cc-image' key={card.slug + '_image'} style={{backgroundImage: `url(${ccImage()})`}}>
        </div>
        : null
      }
    </>
  );
});

export default CoCurricularCard;